<template>
    <div id="business-profile-images-control">
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="mb-4 mt-4 w-full">
                    <vs-table stripe :data="locations" noDataText="No se han generado registros">
                        <template slot="header">
                            <h3>Lista de inmuebles</h3>
                        </template>
                        <template slot="thead">
                            <vs-th class="bold">ID</vs-th>
                            <vs-th class="bold">DIRECCIÓN</vs-th>
                            <vs-th class="bold">TIPO DE INMUEBLE</vs-th>
                            <vs-th class="bold">NOMBRE DEL NEGOCIO</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                                <vs-td :data="data[indextr].id">
                                    {{ (data[indextr].id) }}
                                </vs-td>

                                <vs-td :data="data[indextr].location.address_id">
                                    {{ (data[indextr].location.address.full_address) }}
                                </vs-td>

                                <vs-td :data="data[indextr].location.address_id">
                                    {{ (data[indextr].location.type ? translateType(data[indextr].location.type) : "--")
                                    }}
                                </vs-td>

                                <vs-td :data="data[indextr].location.address_id">
                                    {{ (data[indextr].location.name ? data[indextr].location.name : "--") }}
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "business-profile-images-control",
    props: ["locations"],

    data() {
        return {
           
        }
    },
    mounted() {

    },
    methods: {
        translateType(status) {
            if(status == "home"){
                return "Casa particular";
            } else if(status == "business") {
                return "Negocio";
            } else {
                return "Casa con negocio";
            }
        },
    }

}
</script>

<style>
.con-vs-dialog {
    z-index: 9999999 !important;
}
</style>